import React, { ReactNode } from "react";
import { Paper } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

type StyledPaperProps = {
  width: string;
  minWidth?: string;
  elevation: number;
  children: ReactNode;
};

const StyledPaper = styled(({ width, children, ...other }: StyledPaperProps) => <Paper {...other}>{children}</Paper>)({
  width: ({ width }: StyledPaperProps) => width,
  minWidth: ({ minWidth }: StyledPaperProps) => minWidth,
});

export default StyledPaper;
